export default __webpack_public_path__ + "static/media/06_photo.bc829e94.jpg";